import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import api from '@services/api';
import { Card } from 'antd';
import { ReportForDeploymentProgressResponse, StbGroupResponse } from '@openapi';
import { Link } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';

const optionsUI: ApexOptions = {
  series: [],
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  chart: {
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      export: {
        csv: {
          filename: 'uiDeploy',
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
        },
        svg: {
          filename: 'uiDeploy',
        },
        png: {
          filename: 'uiDeploy',
        },
      },
      autoSelected: 'zoom',
    },
  },
  dataLabels: {
    enabled: true,
    textAnchor: 'middle',
    distributed: false,
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      colors: ['#fff'],
    },
  },
  labels: ['No Updated', 'Updated'],
  colors: ['#ed1313', '#4ded13'],
  title: {
    align: 'center',
  },
  legend: {
    show: false,
  },
  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: true,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: 'dark',
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
  },
};
const optionsFW: ApexOptions = {
  series: [],
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  chart: {
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      export: {
        csv: {
          filename: 'firmwareDeploy',
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
        },
        svg: {
          filename: 'firmwareDeploy',
        },
        png: {
          filename: 'firmwareDeploy',
        },
      },
      autoSelected: 'zoom',
    },
  },
  dataLabels: {
    enabled: true,
    textAnchor: 'middle',
    distributed: false,
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      colors: ['#fff'],
    },
  },
  labels: ['No Updated', 'Updated'],
  colors: ['#ed1313', '#4ded13'],
  title: {
    align: 'center',
  },
  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: true,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: 'dark',
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
  },
  legend: {
    show: false,
  },
};
const optionsLoader: ApexOptions = {
  series: [],
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  colors: ['#ed1313', '#4ded13'],
  chart: {
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      export: {
        csv: {
          filename: 'loaderDeploy',
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
        },
        svg: {
          filename: 'loaderDeploy',
        },
        png: {
          filename: 'loaderDeploy',
        },
      },
      autoSelected: 'zoom',
    },
  },
  dataLabels: {
    enabled: true,
    textAnchor: 'start',
    distributed: false,
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      colors: ['#fff'],
    },
  },
  labels: ['No Updated', 'Updated'],
  title: {
    align: 'center',
  },
  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: true,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: 'dark',
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
  },
  legend: {
    show: false,
  },
};
interface Props {
  selectStb?: StbGroupResponse;
}

const StbDeploy: React.FC<Props> = ({ selectStb }) => {
  const [chartUI, setChartUI] = React.useState(optionsUI);
  const [chartFW, setChartFW] = React.useState(optionsFW);
  const [chartLoader, setChartLoader] = React.useState(optionsLoader);
  const [chartData, setChartData] = React.useState<ReportForDeploymentProgressResponse['stbGroupStats']>();

  React.useEffect(() => {
    if (selectStb?.id) {
      api.reports.getDeployChart({ stbGroupId: selectStb?.id }).then((item) => {
        const newChartData = item.stbGroupStats;
        setChartData(newChartData);
        if (newChartData.size >= 1) {
          setChartUI({
            ...chartUI,
            series: [newChartData?.size - (newChartData.uiSuccessCount || 0), newChartData.uiSuccessCount || 0],
            title: {
              ...chartUI.title,
              text: newChartData.uiVersion,
            },
          });
          setChartFW({
            ...chartFW,
            series: [
              newChartData?.size - (newChartData.firmwareSuccessCount || 0),
              newChartData.firmwareSuccessCount || 0,
            ],
            title: {
              ...chartFW.title,
              text: newChartData.firmwareVersion,
            },
          });
          setChartLoader({
            ...chartLoader,
            series: [newChartData.size - (newChartData.loaderSuccessCount || 0), newChartData.loaderSuccessCount || 0],
            title: {
              ...chartLoader.title,
              text: newChartData.loaderVersion,
            },
          });
        } else {
          setChartUI({
            noData: {
              ...chartUI.noData,
              text: 'No Data',
              style: {
                color: '#0080FFDD',
                fontSize: '25px',
                fontFamily: 'Montserrat',
              },
            },
          });
          setChartFW({
            noData: {
              ...chartFW.noData,
              text: 'No Data',
              style: {
                color: '#0080FFDD',
                fontSize: '25px',
                fontFamily: 'Montserrat',
              },
            },
          });
          setChartLoader({
            noData: {
              ...chartLoader.noData,
              text: 'No Data',
              style: {
                color: '#0080FFDD',
                fontSize: '25px',
                fontFamily: 'Montserrat',
              },
            },
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectStb]);

  return (
    <Card
      title={
        <span>
          {selectStb?.name}(
          <Link to={`${Navigation.Devices}?filterStbGroupId=${selectStb?.id}`}>{chartData?.size}</Link>)
        </span>
      }
      bodyStyle={{
        display: 'grid',
        gridTemplateColumns: 'max-content max-content max-content max-content ',
        gridGap: '10px',
        justifyContent: 'center',
        marginTop: '20px',
      }}
    >
      <ReactApexChart options={chartUI} series={chartUI.series} type="pie" width={320} />
      <ReactApexChart options={chartFW} series={chartFW.series} type="pie" width={320} />
      <ReactApexChart options={chartLoader} series={chartLoader.series} type="pie" width={320} />
      <div
        style={{ display: 'grid', gridColumn: '1/-1', justifyContent: 'center', marginTop: '10px', fontSize: '17px' }}
      >
        <span>Conn. last 24h: {chartData?.connectedLast24HCount}</span>
        <span>Not conn. 1 month: {chartData?.notConnectedLast1MCount}</span>
        <span>Not conn. 3 months: {chartData?.notConnectedLast3MCount}</span>
        <span>Not conn. 6 months: {chartData?.notConnectedLast6MCount}</span>
      </div>
    </Card>
  );
};
export default React.memo(StbDeploy);
